import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, ReactNode } from 'react';
import Layout from '../Layout/Layout';
import {
    Card,
    CardsContainer,
    CardTitle,
    CardTitleContainer,
    ContactButtonLink,
    ContactCardDescription,
    ContactCardTitle,
    Container,
    Description,
    Title,
} from './IndustriesPageStyle';
import Header from '../HeaderDynamicPages/Header';
import IndustriesCard from './IndustriesCard/IndustriesCard';
import { IndustryItemInterface } from '../../interfaces/industries';
import { dataToBreadcrumbsFromNav } from '../../utils/dataToBreadCrumbsFromNav';
import industriesTranslation from '../../JSON/StaticSitesTranslations/industriesTranslations.json';
import { getSiteName } from '../../utils/getSiteName';

interface IndustriesPageProps {
    industriesData: IndustryItemInterface[];
}

const IndustriesPage: FC<IndustriesPageProps> = ({ industriesData }) => {
    const { t } = useTranslation();
    const { language } = useI18next();

    const displayIndustryCard = (): ReactNode =>
        industriesData?.map((cardData: IndustryItemInterface, index: number) => (
            <IndustriesCard key={index} cardData={cardData} />
        ));

    const { category, categoryItem, item } = dataToBreadcrumbsFromNav(
        language,
        t('industriesBreadCrumb').toLowerCase()
    );

    return (
        <Layout
            title={`${getSiteName(language)} | ${t('industriesTitle')}`}
            description={t('industriesDescription')}
            languageVersionsUrl={industriesTranslation}
        >
            <Header category={category} categoryItem={categoryItem} item={item} />
            <Container>
                <Title>{t('industriesTitle')}</Title>
                <Description>{t('industriesDescription')}</Description>
                <CardsContainer>
                    {displayIndustryCard()}
                    <Card isGreyBackground={true}>
                        <CardTitleContainer>
                            <CardTitle>{t('contact')}</CardTitle>
                        </CardTitleContainer>
                        <ContactCardTitle to={`/${language}/contact`}>{t('industriesContactTitles')}</ContactCardTitle>
                        <ContactCardDescription>{t('industriesContactInfo')}</ContactCardDescription>
                        <ContactButtonLink to={`/${language}/contact`}>
                            {t('industriesContactButtonText')}
                        </ContactButtonLink>
                    </Card>
                </CardsContainer>
            </Container>
        </Layout>
    );
};

export default IndustriesPage;
